'use client'

import EnterViewAnimate from '@/components/enterView/animate'
import InsightsDataViewCard from './card'
import { useDataViewContext } from './context'

export default function InsightsDataViewContent() {
  const { data } = useDataViewContext()
  return (
    <section className='section py-7.5 lg:py-12.5'>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-7.5'>
        {data.map((item) => (
          <EnterViewAnimate animate='animate__fadeInUp' key={item.id}>
            <InsightsDataViewCard data={item} />
          </EnterViewAnimate>
        ))}
      </div>
    </section>
  )
}
